const GTMValues = {
  newsTitleTrade: 'PENAWARAN MOBIL BARU',
  callUs: 'HUBUNGI SALES',
};

export default GTMValues;
